/* eslint-disable */ /**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */

import * as Types from '../../../../app/services/types.generated';

import { api } from 'app/graphqlBaseApi';
module.hot?.accept();
export type GetAllDocumentCategoriesQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetAllDocumentCategoriesQuery = { __typename?: 'Query', getAllDocumentCategories: { __typename?: 'GetAllDocumentCategoriesResponse', statusCode: number, success: boolean, errorMessage?: string, errorType?: string, data: Array<{ __typename?: 'DocumentCategory', docId: string, id: number, externalCategory: string, externalSubCategory: string, internalCategory: string, internalFileCategory: string }> } };

export type GetDocumentCategoryByDocIdQueryVariables = Types.Exact<{
  docId: Types.Scalars['String']['input'];
}>;


export type GetDocumentCategoryByDocIdQuery = { __typename?: 'Query', getDocumentCategoryByDocId: { __typename?: 'DocumentCategoryResponse', statusCode: number, success: boolean, errorMessage?: string, errorType?: string, data?: { __typename?: 'DocumentCategory', docId: string, id: number, externalCategory: string, externalSubCategory: string, internalCategory: string, internalFileCategory: string } } };

export type CreateDocumentCategoryMutationVariables = Types.Exact<{
  input: Types.CreateDocumentCategoryInput;
}>;


export type CreateDocumentCategoryMutation = { __typename?: 'Mutation', createDocumentCategory: { __typename?: 'DocumentCategoryResponse', statusCode: number, success: boolean, errorMessage?: string, errorType?: string, data?: { __typename?: 'DocumentCategory', docId: string, id: number, externalCategory: string, externalSubCategory: string, internalCategory: string, internalFileCategory: string } } };

export type UpdateDocumentCategoryMutationVariables = Types.Exact<{
  input: Types.UpdateDocumentCategoryInput;
}>;


export type UpdateDocumentCategoryMutation = { __typename?: 'Mutation', updateDocumentCategory: { __typename?: 'DocumentCategoryResponse', statusCode: number, success: boolean, errorMessage?: string, errorType?: string, data?: { __typename?: 'DocumentCategory', docId: string, id: number, externalCategory: string, externalSubCategory: string, internalCategory: string, internalFileCategory: string } } };

export type DeleteDocumentCategoryMutationVariables = Types.Exact<{
  input: Types.DeleteDocumentCategoryInput;
}>;


export type DeleteDocumentCategoryMutation = { __typename?: 'Mutation', deleteDocumentCategory: { __typename?: 'DeleteDocumentCategoryResponse', statusCode: number, success: boolean, data: boolean, errorMessage?: string, errorType?: string } };


export const GetAllDocumentCategoriesDocument = `
    query GetAllDocumentCategories($limit: Int) {
  getAllDocumentCategories(limit: $limit) {
    statusCode
    success
    data {
      docId
      id
      externalCategory
      externalSubCategory
      internalCategory
      internalFileCategory
    }
    errorMessage
    errorType
  }
}
    `;
export const GetDocumentCategoryByDocIdDocument = `
    query GetDocumentCategoryByDocId($docId: String!) {
  getDocumentCategoryByDocId(docId: $docId) {
    statusCode
    success
    data {
      docId
      id
      externalCategory
      externalSubCategory
      internalCategory
      internalFileCategory
    }
    errorMessage
    errorType
  }
}
    `;
export const CreateDocumentCategoryDocument = `
    mutation CreateDocumentCategory($input: CreateDocumentCategoryInput!) {
  createDocumentCategory(input: $input) {
    statusCode
    success
    data {
      docId
      id
      externalCategory
      externalSubCategory
      internalCategory
      internalFileCategory
    }
    errorMessage
    errorType
  }
}
    `;
export const UpdateDocumentCategoryDocument = `
    mutation UpdateDocumentCategory($input: UpdateDocumentCategoryInput!) {
  updateDocumentCategory(input: $input) {
    statusCode
    success
    data {
      docId
      id
      externalCategory
      externalSubCategory
      internalCategory
      internalFileCategory
    }
    errorMessage
    errorType
  }
}
    `;
export const DeleteDocumentCategoryDocument = `
    mutation DeleteDocumentCategory($input: DeleteDocumentCategoryInput!) {
  deleteDocumentCategory(input: $input) {
    statusCode
    success
    data
    errorMessage
    errorType
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    GetAllDocumentCategories: build.query<GetAllDocumentCategoriesQuery, GetAllDocumentCategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetAllDocumentCategoriesDocument, variables })
    }),
    GetDocumentCategoryByDocId: build.query<GetDocumentCategoryByDocIdQuery, GetDocumentCategoryByDocIdQueryVariables>({
      query: (variables) => ({ document: GetDocumentCategoryByDocIdDocument, variables })
    }),
    CreateDocumentCategory: build.mutation<CreateDocumentCategoryMutation, CreateDocumentCategoryMutationVariables>({
      query: (variables) => ({ document: CreateDocumentCategoryDocument, variables })
    }),
    UpdateDocumentCategory: build.mutation<UpdateDocumentCategoryMutation, UpdateDocumentCategoryMutationVariables>({
      query: (variables) => ({ document: UpdateDocumentCategoryDocument, variables })
    }),
    DeleteDocumentCategory: build.mutation<DeleteDocumentCategoryMutation, DeleteDocumentCategoryMutationVariables>({
      query: (variables) => ({ document: DeleteDocumentCategoryDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetAllDocumentCategoriesQuery, useLazyGetAllDocumentCategoriesQuery, useGetDocumentCategoryByDocIdQuery, useLazyGetDocumentCategoryByDocIdQuery, useCreateDocumentCategoryMutation, useUpdateDocumentCategoryMutation, useDeleteDocumentCategoryMutation } = injectedRtkApi;

